// Which build of the app is running, as it can be read from the page.
//
// WHY THIS EXISTS. Geometry drawn on a sheet is stored as percentages of
// that sheet, so it is only as correct as the code that measured it. A
// bug in that measurement (the overlay was once registered to the box
// around the drawing rather than to the drawing) makes every point
// recorded by that build wrong - and afterwards there is no way to tell
// which points those were. Auditing it meant inferring from timestamps
// against deploy times, which is guesswork the moment two environments
// or a rollback are involved.
//
// So a client that records geometry stamps WHICH BUILD recorded it, and
// the question stops being a reconstruction.
//
// The content hash in the main chunk's filename is the build id: it is
// already unique per build, it is already on the page, and it needs no
// build-script change to produce - which matters, because a build id
// that depends on someone remembering to set an env var is a build id
// that is missing exactly when it is wanted.
let cached = null;

export function buildVersion() {
  if (cached !== null) return cached;
  cached = "";
  try {
    const src = Array.from(document.getElementsByTagName("script"))
      .map((s) => s.src || "")
      .find((s) => /\/static\/js\/main\.[a-f0-9]+\.chunk\.js/.test(s));
    const m = src && src.match(/main\.([a-f0-9]+)\.chunk\.js/);
    if (m) cached = m[1];
  } catch (e) {
    // A dev server serves main.chunk.js with no hash, and a test
    // environment has no script tags at all. An empty string is the
    // honest answer - "this build did not say" - and it is what the
    // audit query keys on.
    cached = "";
  }
  return cached;
}

export default buildVersion;
